module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui medium statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.data.fullName))])]), _vm._v(" "), _c('div', {
    staticClass: "subdued"
  }, [_vm._v("\n        " + _vm._s(_vm.data.valueName) + "\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "widget list"
  }, _vm._l((_vm.formattedList), function(line, index) {
    return _c('li', [_c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(line.value))]), _vm._v("\n             \n            "), (_vm.data.showNumbers) ? _c('span', [_vm._v(_vm._s(index + 1) + ".")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v("\n                " + _vm._s(_vm._f("elipsis")(line.name, 17)) + "\n            ")])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8413d092"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MetricListWidget.vue
// module id = 394
// module chunks = 1